import { foldout2Styling } from "@made-people/blueprint-menu/blueprint";

foldout2Styling.main.override({
  slots: {
    wrapper: "w-[calc(100vw-72px)] max-w-96 min-h-full bg-white",
    header: "flex items-center p-4 px-5 h-[72px]",
    title: "block text-label-md px-2",
    backButton:
      "w-4 h-8 flex justify-center items-center box-border [&>svg]:-translate-x-px",
    closeButtonOutside:
      "w-8 h-8 p-2.5 box-border text-right absolute -right-11 top-5 flex justify-center items-center rounded-full bg-white shadow-lg",
    closeButtonInside:
      "ml-auto w-8 h-8 flex justify-center items-center p-2.5 box-border -mr-2",
    buttonWrapper: "col-span-6",
    content: "h-[calc(100vh-72px)]",
    component: "px-5 my-2",
  },
});

foldout2Styling.menuItem.override({
  slots: {
    wrapper: "w-full",
    item: "group w-full flex items-center py-1 px-5 box-border text-base data-[level=1]:py-2.5 data-[level=1]:text-heading-display-sm data-[level=1]:font-display",
    label: "flex items-center w-full h-full gap-2",
    link: "",
    goToNextLevel:
      "w-8 h-6 flex justify-center items-center shrink-0 box-border [&>svg]:translate-x-px [&>svg]:size-3 -mr-2",
    submenu: "min-h-full mb-7 ",
    submenuComponent: "px-5 my-4",
    submenuHeading:
      "block z-10 px-5 py-2 text-eyebrow-sm uppercase text-less-emphasis-1 font-normal sticky top-0 bg-white",
    badge: "self-start -mt-1",
    scrollContainer: "overflow-y-scroll scroll-smooth scrolling-touch",
  },
});
